import React from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import ChangePasswordContent from "../forgot_password/ChangePasswordContent";

function ChangePasswordMain() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>
      
      {/*navbar*/}
      <NavBar />
      {/* Body */}
      <ChangePasswordContent />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default ChangePasswordMain;
